import type {AxiosInstance, AxiosRequestConfig} from 'axios'
import axios from 'axios'
import AuthorizeJwtInterceptor from '../services/authorize-jwt.interceptor'

axios.defaults.withCredentials = true;

const createApiClient = (config?: AxiosRequestConfig): AxiosInstance => {
  const instance = axios.create({
    baseURL: '/api',
    withCredentials: true,
    ...config
  });
  AuthorizeJwtInterceptor.setAuthorizationHeader(instance);
  AuthorizeJwtInterceptor.renewAccessToken(instance);
  return instance;
};

const apiClient = createApiClient();

const apiClientPdf: AxiosInstance = axios.create({
  baseURL: '/api',
  responseType: 'blob',
  withCredentials: true
})

const apiClientImport: AxiosInstance = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})


// AuthorizeJwtInterceptor.setAuthorizationHeader(apiClientPdf)
// AuthorizeJwtInterceptor.renewAccessToken(apiClientPdf)

// AuthorizeJwtInterceptor.setAuthorizationHeader(apiClientImport)
// AuthorizeJwtInterceptor.renewAccessToken(apiClientImport)

export class BaseHttpService {
  /**
   * Send POST request
   *
   * @param path request URI
   * @param body Request parameter (attached to the request body) FormData
   * @protected
   */
  protected postPromise(path: string, body?: any): Promise<any> {
    return apiClient.post(path, body)
  }

  protected putPromise(path: string, body?: any): Promise<any> {
    return apiClient.put(path, body)
  }

  /**
   * Send Get request
   *
   * @param path Path request URI
   * @param body Request parameter
   * @protected
   */
  protected getPromise(path: string, body?: any): Promise<any> {
    return apiClient.get(path, { params: body })
  }

  /**
   * Send POST request with responseType is Blob
   *
   * @param path Path request URI
   * @param body Request parameter
   * @protected
   */
  protected postPromisePDF(path: string, body?: any): Promise<any> {
    return apiClientPdf.post(path, body)
  }

  /**
   * Send GET request with responseType is Blob
   *
   * @param path Path request URI
   * @param body Request parameter
   * @protected
   */
  protected getPromisePDF(path: string, body?: any): Promise<any> {
    return apiClientPdf.get(path, { params: body })
  }

  /**
   * Send POST request by import File
   *
   * @param path Path request URI
   * @param body Request parameter
   * @protected
   */
  protected postPromiseImport(path: string, body?: any): Promise<any> {
    return apiClientImport.post(path, body)
  }

  protected getPromiseThirdParty(path: string, body?: any, headers?: any): Promise<any> {
    return axios.get(path, {
      params: body,
      headers: headers
    });
  }
}
